import { useContext, useMemo } from 'react'

import { AnalyticsQueryFilter } from '@hap/analytics'

import { SavedQueryContext } from '../context'

export function useSavedQueryParams() {
  const { state } = useContext(SavedQueryContext)
  const flattenedFilters = useMemo(() => {
    return state.data.params.filters.reduce<AnalyticsQueryFilter[]>((acc, filter) => {
      if (filter.compound) return [...acc, filter, ...filter.compound]
      return [...acc, filter]
    }, [])
  }, [state.data.params.filters])
  return {
    ...state.data.params,
    flattenedFilters: flattenedFilters,
  }
}

export function useSavedQueryPagination() {
  const { pagination } = useContext(SavedQueryContext)
  return pagination
}

export function useSavedQuerySettings() {
  const { state } = useContext(SavedQueryContext)
  return {
    name: state.data.name,
    shared: state.data.shared,
    saved: state.data.saved,
    description: state.data.description,
  }
}

export function useSavedQuery() {
  const { state } = useContext(SavedQueryContext)
  return state
}

export function useSavedQueryId() {
  const context = useContext(SavedQueryContext)
  return context.id
}
